import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Eyebrow } from "@/components/shared/Eyebrow";
import { Reveal } from "@/components/shared/Reveal";
import { ContactForm } from "@/components/shared/ContactForm";
import { useSettings } from "@/hooks/useContent";
import { isReal } from "@/lib/display";

export function ContactSection() {
  const { data: s } = useSettings();
  const items = [
    { icon: Phone, label: "Telefon", value: s?.company_phone, href: s?.company_phone ? `tel:${s.company_phone.replace(/[^0-9+]/g, "")}` : null },
    { icon: Mail, label: "E-posta", value: s?.company_email, href: s?.company_email ? `mailto:${s.company_email}` : null },
    { icon: MapPin, label: "Adres", value: s?.company_address },
    { icon: Clock, label: "Çalışma Saatleri", value: s?.working_hours },
  ].filter((it) => isReal(it.value));

  return (
    <section data-testid="contact-section" className="relative bg-dark text-white py-24 md:py-28 overflow-hidden">
      <div className="absolute inset-0 grid-lines-dark opacity-40" />
      <div className="relative mx-auto max-w-[1400px] px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Eyebrow dark className="mb-6">İLETİŞİM</Eyebrow>
            <Reveal>
              <h2 className="font-head font-extrabold tracking-tight text-4xl md:text-5xl leading-[1.05]">
                Bir projeniz mi var?
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-silver/70 leading-relaxed max-w-md">
                İhtiyaçlarınızı dinleyelim, size en uygun mühendislik çözümünü birlikte planlayalım.
              </p>
            </Reveal>
            <div className="mt-10 space-y-6">
              {items.map((it) => {
                const Icon = it.icon;
                return (
                  <div key={it.label} className="flex gap-4">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center border border-white/15 text-cyan">
                      <Icon className="w-5 h-5" strokeWidth={1.5} />
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-wide text-silver/50">{it.label}</p>
                      {it.href
                        ? <a href={it.href} className="text-white mt-0.5 block hover:text-cyan transition-colors">{it.value}</a>
                        : <p className="text-white mt-0.5">{it.value}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="border border-white/10 bg-dark-2/50 p-6 md:p-10">
              <ContactForm dark />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
